module.exports = __webpack_public_path__ + "img/yq5.a6577c25.png";